import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  StatusFormatter,
  columnsComplate,
  columnsUploadTSA,
  components,
  dateDefault,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  selectStyles,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
  useStylesSelect,
  validatePost
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  addUploadFileTSA,
  editInbound,
  editVehicleTSA,
  editVehicleConfrim,
  fetchFileTemplate,
  fetchFileTemplateBlob,
  fetchIdInbound,
  fetchIdVehicleFind,
  fetchVehicleInboundWorkflow,
  removeVehicle,
  removeVehicleWorkFlow,
  selectIdInbound,
  selectInspection,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicle,
  removeVehicleWorkFlowTSA,
} from "./inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import InputNumber from "../../utility/InputNumber";
import { ModalLocationRadio } from "./ModalLocationRadio";
import {
  prosesUpload,
  prosesUploadCancel,
} from "../miscellaneous/MiscellaneousSlice";
import { env } from "../../../env";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const TSAPage = ({
  active,
  paramFilter,
  setParamFilter,
  paramValue,
  setParamValue,
  value,
  setValue,
  formValues,
  setFormValues,
  show,
  setShow,
  showScan,
  setShowScan,
  showDetailDamage,
  setShowDetailDamage,
  create,
  setCreate,
}) => {
  const classes = useStyles();
  const classesSelect = useStylesSelect();

  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdInbound);
  const data = useSelector(selectVehicle);
  const dataInspetion = useSelector(selectInspection);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const [status, setStatus] = useState("");
  const [force, setForce] = useState(false);
  const inputRef = useRef(null);

  const [tableData, setTableData] = useState([]);

  const [row, setRow] = useState(null);
  const [rowIndex, setRowIndex] = useState(null);
  const [formatExtraData, setFormatExtraData] = useState([]);
  const [rowInspection, setRowInspection] = useState(null);
  const [rowIndexInspection, setRowIndexInspection] = useState(null);
  const [listInspection, setListInspection] = useState([]);
  const [listInspectionCreate, setListInspectionCreate] = useState([]);
  const [columnsInspection, setColumnsInspection] = useState([]);
  const [detailDamage, setDetailDamage] = useState([]);

  const [vin, setVin] = useState("");
  const [von, setVon] = useState("");
  const [engineNo, setEngineNo] = useState("");
  const [mileage, setMileage] = useState("");
  const [keyNumber, setKeyNumber] = useState("");
  const [inspectoinResult, setInspectoinResult] = useState("OK");
  const [remarks, setRemark] = useState("");
  const [inbounRule, setInbounRule] = useState("N");

  const [getData, setGetData] = useState(false);
  const [scanFrom, setScanFrom] = useState("");

  useEffect(() => {
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1,
        // list: list,
        // listColumns: listDamage,
      };
    });

    setTableData(initData);
  }, [data]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setParamValue("");
      setParamFilter("");
      setForce(false);
    }
  }, [force]);

  const vehiclesOptions = [
    {
      value: "vin",
      label: "VIN",
    },
    {
      value: "von",
      label: "VON",
    },
    {
      value: "master_code",
      label: "Master Code ",
    },
    {
      value: "model_code",
      label: "Model Code ",
    },
    {
      value: "color_code",
      label: "Color Code ",
    },
  ];

  console.log(value, "value");

  const handleChangeVehicles = (e) => {
    if (e === null) {
      e = undefined;
      setParamFilter("");
    } else {
      setParamFilter(e.value);
    }
  };

  const handleSearch = async () => {
    let result;
    let params = {};

    if (value === 0) {
      result = "4030,5010,5020";
    } else if (value === 1) {
      result = "4030,5010,5020";
      params.is_planned = "N";
    } else if (value === 2) {
      result = "5030";
      params.is_planned = "Y,N";
    }

    params[paramFilter] = paramValue;
    params.vehicle_status = result;
    params.inbound_id = id;
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchVehicleInboundWorkflow(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let result;
      let params = {};

      if (value === 0) {
        result = "4030,5010,5020";
      } else if (value === 1) {
        result = "4030,5010,5020";
        params.is_planned = "N";
      } else if (value === 2) {
        result = "5030";
        params.is_planned = "Y,N";
      }
      params[paramFilter] = paramValue;
      params.vehicle_status = result;
      params.inbound_id = id;
      params.pageNo = page;
      params.pageSize = sizePerPage;

      try {
        const response = await dispatch(fetchVehicleInboundWorkflow(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      setTableData(result);
    }
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };


  const actionFormatterInspection = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={() => {
                const initData = row.detail.map((item, index) => {
                  return {
                    ...item,
                    no: index + 1,
                  };
                });

                setDetailDamage(initData);

                setRowInspection(row);
                setRowIndexInspection(rowIndex);

                setShowDetailDamage(true);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
              </span>
            </div>
          </OverlayTrigger>
        </div>
      </>
    );
  };
  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          {row.vehicle_status !== "4030" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={() => {
                  const initData = row.listInspection.map((item, index) => {
                    return {
                      ...item,
                      no: index + 1,
                    };
                  });

                  const result = row.listColumn.map((item) => {
                    return {
                      text: item,
                      dataField: item,
                      // editable: false,
                    };
                  });

                  const finalResult = [
                    {
                      text: "Category",
                      dataField: "category_name",
                    },
                    {
                      text: "Inspection Point",
                      dataField: "name",
                    },
                    ...result,
                    {
                      dataField: "actions",
                      text: "Actions",
                      formatter: actionFormatterInspection,
                    },
                  ];
                  setRow(row);
                  setRowIndex(rowIndex);
                  setListInspection(initData);
                  setColumnsInspection(finalResult);
                  setFormValues({
                    vin: {
                      value: row.vin,
                      error: false,
                      required: "Y",
                    },
                    von: {
                      value: row.von,
                      error: false,
                      required: "N",
                    },
                    location: {
                      value:
                        row.location_tsa_id === null ? "" : row.location_tsa_id,
                      error: false,
                      required: "Y",
                    },
                    location_name: {
                      value: row.to_location,
                      error: false,
                      required: "Y",
                    },
                    storage_date: {
                      value: row.storage_date,
                      error: false,
                      required: "Y",
                    },
                  });
                  setVon(row.von);
                  setEngineNo(row.engine_no);
                  setMileage(row.mileage);
                  setKeyNumber(row.key_no);
                  setInspectoinResult(row.inspection_result);
                  setRemark(row.remarks);
                  setInbounRule(row.inbound_rule);
                  setCreate(false);
                  setShow(true);
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  {value === 2 ? (
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")}
                    />
                  ) : (
                    <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                  )}
                </span>
              </div>
            </OverlayTrigger>
          )}
          {row.vehicle_status !== "4030" && (
            <>
              {value !== 2 && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-delete-tooltip">Delete</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                   onClick={(e) =>
                      handleDelete(e, row )
                    }
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Require Acc. Installation",
      dataField: "inbound_rule",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: StatusFormatter,
      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    // {
    //   text: "Inspection Result",
    //   dataField: "inspection_result",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    //   headerAlign: "center",
    //   style: { minWidth: "200px" },
    // },
    {
      text: "Engine No.",
      dataField: "engine_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Key No.",
      dataField: "key_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "Mileage",
      dataField: "mileage",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "From Location",
      dataField: "from_location_tsa",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "To Location",
      dataField: "to_location",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "Storage Date",
      dataField: "storage_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "60px" },
      formatter : formatDate
    },
    {
      text: "User",
      dataField: "tsa_updatedby",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "60px" },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  const handleQty = (e, row, rowIndex, formatExtraData) => {
    if (parseFloat(row.value) > parseFloat(row.max_weight)) {
      row.value = row.max_weight;
      forceUpdate();
      return true;
    } else if (parseFloat(row.value) < 0) {
      row.value = 0;
      forceUpdate();
      return true;
    }
  };

  const inputValue = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        step="any"
        className="input-box-table"
        value={parseFloat(row.value)}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };

  const columnsDetailDamage = [
    {
      text: "Name",
      dataField: "name",
      editable: false,
    },

    {
      text: "value",
      dataField: "value",
      formatter: inputValue,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
    },
  ];
  const [showLocation, setShowLocation] = useState(false);

  const handleClose = () => {
    setFormValues({
      vin: {
        value: "",
        error: false,
        required: "Y",
      },
      von: {
        value: "",
        error: false,
        required: "N",
      },
      location: {
        value: "",
        error: false,
        required: "Y",
      },
      location_name: {
        value: "",
        error: false,
        required: "Y",
      },
      storage_date: {
        value: "",
        error: false,
        required: "Y",
      },
    });
    setVin("");
    setVon("");
    setEngineNo("");
    setMileage("");
    setKeyNumber("");
    setInspectoinResult("");
    setRemark("");
    setInbounRule("N");
    setShow(false);
    setRow(null);
  };
  const handleCloseScan = () => {
    setScanFrom("");
    setShowScan(false);
  };

  const handleSave = async (status) => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    let params;

    console.log(row, "row");

    if (create === true) {
      params = {
        inbound_id: id,
        vin: formValues.vin.value,
        location_tsa_id: formValues.location.value,
        von: formValues.von.value,
        manual_action_date: formValues.storage_date.value,
        remarks: remarks,
        preferences_id: dataInspetion === null ? "" : dataInspetion.preferences_id,
        vehicle_status: "5010",
      };
    } else {
      params = {
        inbound_id: id,
        vin: formValues.vin.value,
        location_tsa_id: formValues.location.value,
        von: formValues.von.value,
        manual_action_date: formValues.storage_date.value,
        remarks: remarks,
        vehicle_id: row !== null ? row.vehicle_id : "",
        // vehicle_status: row.vehicle_status === "5010" ? null : "5010",
        vehicle_status: "5010",
      };
    }

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleTSA(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleSearch();
        await handleClose();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleSaveConfrim = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const params = {
      inbound_id: id,
      vin: formValues.vin.value,
      location_tsa_id: formValues.location.value,
      von: formValues.von.value,
      manual_action_date: formValues.storage_date.value,
      remarks: remarks,
      // vehicle_id: row !== null ? row.vehicle_id : "",
      vehicle_status: "5010",
    };
    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleTSA(params));
      if (response.payload.status === 200) {
        const responseConfirm = await dispatch(
          editVehicleTSA({
            ...params,
            vehicle_status: "5030",
          })
        );

        if (responseConfirm.payload.status === 200) {
          const action = await showSuccessDialog(
            responseConfirm.payload.data.message
          );
          await handleClose();
          await dispatch(fetchIdInbound(id));
          await handleSearch();
        } else {
          await handleClose();
          showErrorDialog(responseConfirm.payload.data.message);
        }
      } else {
        await handleClose();

        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      await handleClose();

      console.log(error.message);
    }
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const handleModalCreate = () => {
    const initData =
      dataInspetion !== null
        ? dataInspetion.listInspection.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          })
        : [];

    const result =
      dataInspetion !== null
        ? dataInspetion.listColumn.map((item) => {
            return {
              text: item,
              dataField: item,
              // editable: false,
            };
          })
        : [];

    const finalResult = [
      {
        text: "Category",
        dataField: "category_name",
      },
      {
        text: "Inspection Point",
        dataField: "name",
      },
      ...result,
      {
        dataField: "actions",
        text: "Actions",
        formatter: actionFormatterInspection,
      },
    ];
    setListInspection(initData);
    setColumnsInspection(finalResult);
    setCreate(true);
    setShow(true);
  };

  const handleConfirm = async () => {
    const params = {
      inbound_id: id,
      vehicle_status: "5030",
    };

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleConfrim(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  const handleComplate = async () => {
    const params = {
      inbound_id: id,
      vehicle_status: "5030",
    };

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleConfrim(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDelete = async (e, row) => {
    const params = [
      {
        vehicle_id: `${row.vehicle_id}`,
        document_id: id,
      },
    ];
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(
          removeVehicleWorkFlowTSA({ data: params })
        );
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleInspectionResultChange = (event) => {
    setInspectoinResult(event.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const [fieldsLocation, setFieldsLocation] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const handleModalEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleFind = async () => {
    if (scanFrom === "") {
      return showDialog("Please scan or enter code");
    }
    const params = `${scanFrom}?document_id=${id}`;
    try {
      const response = await dispatch(fetchIdVehicleFind(params));

      if (response.payload.status === 200) {
        const dataId = response.payload.data.data;
        setFormValues({
          ...formValues,
          vehicle_id: {
            value: dataId.vehicle_id,
            error: false,
            required: "N",
          },
          vin: {
            value: dataId.vin,
            error: false,
            required: "Y",
          },
          von: {
            value: dataId.von,
            error: false,
            required: "N",
          },
          location: {
            value:
              dataId.location_tsa_id === null ? "" : dataId.location_tsa_id,
            error: false,
            required: "Y",
          },
          location_name: {
            value: dataId.to_location,
            error: false,
            required: "Y",
          },
          storage_date: {
            value: dataId.storage_date,
            error: false,
            required: "Y",
          },
        });

        setShowScan(false);
        setCreate(true);
        setShow(true);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // upload file
  const [fileName, setFileName] = useState("Upload Template File");
  const [file, setFile] = useState(null);
  const [rowUpload, setRowUpload] = useState(null);
  const [showUploadView, setShowUploadView] = useState(false);

  const [showUpload, setShowUpload] = useState(false);

  const handleCloseUpload = () => {
    setShowUpload(false);
    setFile(null);
    setFileName("Upload Template File");
  };
  const handleCloseUploadView = () => {
    setShowUploadView(false);
    setRowUpload(null);
  };

  const handleUpload = async () => {
    // if (file) {
    //   return showErrorDialog("Please Input");
    // }
    const params = {
      id: id,
      file: file,
    };
    try {
      const response = await dispatch(addUploadFileTSA(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleCloseUpload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleProses = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUpload(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleCloseUploadView();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleProsesCancel = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUploadCancel(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleCloseUploadView();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDownload = async () => {
    const params = {
      id: id,
      type: "TSA",
    };
    try {
      const response = await dispatch(fetchFileTemplate(params));
      if (response.payload.status === 200) {
        const response = await dispatch(fetchFileTemplateBlob(params));
        if (response.payload.status === 200) {
          const blob = new Blob([response.payload.data], {
            type: "application/xlsx",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "STORAGE.xlsx";
          link.click();
        }
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              setRowUpload(row);
              setShowUploadView(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardBody>
          <div className="d-flex mb-5 mt-5">
            <div className="p-2">
              <Button
                className="my-btn-primary-dark "
                onClick={(e) => setShowScan(true)}
              >
                Input Storage Details
              </Button>
            </div>
            <div className="mr-auto p-2 ">
              <Button
                className="my-btn-primary-dark "
                onClick={(e) => setShowUpload(true)}
              >
                Upload Storage Details
              </Button>
            </div>
            <div className="p-2">
              <Button variant="outline-primary" onClick={handleConfirm}>
                Confirm
              </Button>
            </div>
          </div>
          <>
            <Tabs
              value={value}
              onChange={handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
              fullWidth
            >
              <Tab label={`Planned Vehicles`} />
              <Tab label={`Unplanned Vehicles`} />
              <Tab label={`Confirmed Vehicles`} />
            </Tabs>
            {/*  Planned Vehicles*/}
            {value === 0 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            {value === 1 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            {value === 2 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}

            <hr />
            <div className="mb-3">
              <p className="font-weight-boldest">File Upload Progress</p>
              <Row>
                <Col md={4}>
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    keyField="no"
                    data={
                      dataId.tableUploadsTSAs !== null
                        ? dataId.tableUploadsTSAs
                        : []
                    }
                    columns={columnsFile}
                    hover
                  />
                </Col>
              </Row>
            </div>
          </>
        </CardBody>
      </Card>

      <>
        {/* Modal Inspection */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Input Storage Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="VIN"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="vin"
                    value={formValues.vin.value}
                    onChange={handleChange}
                    error={formValues.vin.error}
                    helperText={
                      formValues.vin.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                    disabled
                  />
                  <RedditTextField
                    label="VON"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="von"
                    value={formValues.von.value}
                    disabled
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Row>
                    <Col xs={10} sm={3} md={10} lg={10}>
                      <RedditTextField
                        required
                        label="Location"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        value={formValues.location_name.value}
                        onChange={handleChange}
                        error={formValues.location.error}
                        helperText={
                          formValues.location.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                      <RedditTextField
                        required
                        label="Storage Area Date"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        type="datetime-local"
                        size="small"
                        fullWidth
                        name="storage_date"
                        value={formValues.storage_date.value}
                        onChange={handleChange}
                        error={formValues.storage_date.error}
                        helperText={
                          formValues.storage_date.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Col>
                    <Col xs={1} sm={1} md={1} lg={1}>
                      <div>
                        <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                          <span
                            className="svg-icon svg-icon-md svg-icon-light"
                            onClick={() => {
                              setGetData(true);
                              setShowLocation(true);
                            }}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {value !== 2 && (
              <>
                <Button variant="primary" onClick={(e) => handleSave("save")}>
                  Save
                </Button>
                <Button variant="primary" onClick={handleSaveConfrim}>
                  Confirm
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>

        <ModalLocationRadio
          isOpen={showLocation}
          setShow={setShowLocation}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFieldsLocation}
          fields={fieldsLocation}
          getData={getData}
          setGetData={setGetData}
        />
        {/* scann */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showScan}
          onHide={handleCloseScan}
          onEntered={handleModalEntered}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Scan or Enter Code
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Form.Control
                    ref={inputRef}
                    type="text"
                    value={scanFrom}
                    onChange={(e) => setScanFrom(e.target.value)}
                  />
                </Col>
              </Row>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseScan}>
              Close
            </Button>
            <Button variant="primary" onClick={handleFind}>
              Find
            </Button>
          </Modal.Footer>
        </Modal>

        {/* upload */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUpload}
          onHide={handleCloseUpload}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Upload Storage
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-5">
              <h5 className="font-weight-boldest">File</h5>

              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Form.File
                    type="file"
                    id="file_fpre"
                    custom
                    label={fileName}
                    onChange={(e) => {
                      setFile(e.target.files[0]);
                      setFileName(e.target.files[0].name);
                    }}
                    accept=".xlsx, .XLSX"
                  />
                </Col>
                <Col>
                  <Button
                    variant="primary"
                    className="mr-5"
                    onClick={handleUpload}
                  >
                    Upload
                  </Button>

                  <Button variant="outline-primary" onClick={handleDownload}>
                    Download Template
                  </Button>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseUpload}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* upload View */}
        {rowUpload && (
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showUploadView}
            onHide={handleCloseUploadView}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Upload Vehicle Information Status
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div class="d-flex mb-5">
                <div class="p-2 mr-auto font-weight-boldest ">
                  Uploaded Vehicles Data from file "{rowUpload.file_name}"
                </div>
                <div class="p-2 font-weight-boldest">
                  Status :{rowUpload.status}{" "}
                </div>
              </div>
              {rowUpload.status === "Uploaded" && (
                <Row className="ml-2 mb-5">
                  <Button
                    variant="primary"
                    className="mr-5"
                    onClick={handleProses}
                  >
                    Process Data
                  </Button>
                  <Button variant="danger" onClick={handleProsesCancel}>
                    Cancel Process Data
                  </Button>
                </Row>
              )}

              <>
                <div
                  className=" "
                  style={{
                    maxHeight: "600px",
                    overflowY: "scroll",
                  }}
                >
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    keyField="no"
                    data={rowUpload !== null ? rowUpload.data : []}
                    columns={columnsUploadTSA}
                    hover
                  />
                </div>
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseUploadView}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    </>
  );
};
